import { TipoAtestadoEnum } from 'graphql/types.generated'
import { OBSERVACAO_DISABLE_EDIT_AND_REMOVE_ATESTADOS_TOOLTIP_TEXT } from 'view/atendimentos/atendimento-individual/atendimento-observacao/model-atendObservacao'

export const ASSINATURA_CIDADAO_TEXT = 'ASSINATURA DO CIDADÃO OU RESPONSÁVEL'
export const CID10_DESCRICAO_ATESTADO = ', com o diagnóstico segundo CID10 '

export const NAO_E_POSSIVEL_EDITAR_ATESTADOS_GERADOS_DIGITALMENTE_E_ENVIADOS_TOOLTIP_TEXT =
  'Não é possível editar ou excluir atestados que foram gerados digitalmente e enviados ao cidadão'
export const ATESTADO_REGISTRADO_EM_OUTRO_ATENDIMENTO_TOOLTIP_TEXT = 'Atestado registrado em outro atendimento'
export const DEFAULT_ATESTADO_TOOLTIP_TEXT = 'Mais opções'

export const atestadoComCID10Text = ({ nomeCidadao, nomeProfissional }) =>
  `Eu, ${nomeCidadao.titleCase()}, autorizo o(a) Dr.(a) ${nomeProfissional} a registrar o diagnóstico codificado CID10 neste atestado.`

export const tituloAtestado = (tipoAtestado: TipoAtestadoEnum) =>
  tipoAtestado === TipoAtestadoEnum.LICENCA_MATERNIDADE ? 'LICENÇA MATERNIDADE' : 'ATESTADO'

export const getTooltipTextMaisOpcoesAtestado = (
  isAssinadoDigitalmente: boolean,
  isRegistroRecente: boolean,
  isEditable: boolean
): string => {
  if (isAssinadoDigitalmente && isRegistroRecente)
    return NAO_E_POSSIVEL_EDITAR_ATESTADOS_GERADOS_DIGITALMENTE_E_ENVIADOS_TOOLTIP_TEXT

  if (isEditable) return OBSERVACAO_DISABLE_EDIT_AND_REMOVE_ATESTADOS_TOOLTIP_TEXT

  if (!isRegistroRecente || isAssinadoDigitalmente) return ATESTADO_REGISTRADO_EM_OUTRO_ATENDIMENTO_TOOLTIP_TEXT

  return DEFAULT_ATESTADO_TOOLTIP_TEXT
}
